import React from 'react';
import { Table } from 'antd';

import { TableProps, TablePaginationConfig } from 'antd/es/table';
import type { ColumnsType } from 'antd/es/table';

interface IProps<T extends { id: string | number }> extends TableProps<T> {
	loading: boolean;
	columns: ColumnsType<T>;
	data: T[] | undefined;
	emptyTable: React.ReactNode | (() => React.ReactNode);
	pagination?: TablePaginationConfig | false;
	widthPerColumn?: number;
	excludeWidthColumn?: boolean;
	tableMaxHeight?: number;
	tableMaxWidth?: number | string;
}

function CustomResponsiveTable<T extends { id: string | number }>({
	loading,
	columns,
	data,
	emptyTable,
	pagination,
	widthPerColumn = 145,
	excludeWidthColumn = false,
	tableMaxHeight = 95,
	tableMaxWidth = 1440,
	onRow,
	onChange,
	...rest
}: IProps<T>) {
	const includeWidthColumns = columns.map((item) => {
		return { ...item, width: widthPerColumn }; // Se mantiene la asignación de width
	});

	return (
		<Table
			className="records-list"
			columns={excludeWidthColumn ? columns : includeWidthColumns}
			rowKey={(record) => record?.id?.toString()}
			loading={loading}
			dataSource={data ? data : []}
			locale={{ emptyText: emptyTable }}
			pagination={pagination}
			onRow={onRow}
			onChange={onChange}
			scroll={{ y: `calc(${tableMaxHeight}vh - 250px)`, x: tableMaxWidth }}
			tableLayout="fixed"
			{...rest}
		/>
	);
}

export default CustomResponsiveTable;
